import { useState } from 'react';

// ----------------------------------------------------------------------

export function useLightBox(slides, defaultIndex) {
  const [selected, setSelected] = useState(defaultIndex ?? -1);

  const handleOpen = (slideUrl) => {
    const slideIndex = slides.findIndex(({ src, type, poster }) =>
      type.includes('video') ? poster === slideUrl : src === slideUrl
    );
    setSelected(slideIndex);
  };

  const handleClose = () => setSelected(-1);

  return {
    selected,
    open: selected >= 0,
    onOpen: handleOpen,
    onClose: handleClose,
    setSelected,
  };
}
